export type LikelihoodColor = 'red' | 'orange' | 'yellow' | 'green' | 'lightgreen';

export const getLikelihoodColor = (likelihood: number): LikelihoodColor => {
  if (likelihood > 0 && likelihood < 0.2) return 'red';
  if (likelihood >= 0.2 && likelihood < 0.3) return 'orange';
  if (likelihood >= 0.3 && likelihood < 0.5) return 'yellow';
  if (likelihood >= 0.5 && likelihood < 0.7) return 'green';
  if (likelihood >= 0.7) return 'lightgreen';
  return 'red';
};

export const getAzureHeatmapColorExpression = (showColor: boolean): any => {
  if (showColor) {
    return [
      'interpolate',
      ['linear'],
      ['heatmap-density'],
      0, 'rgba(255, 0, 0, 0)',
      0.2, 'red',
      0.3, 'orange',
      0.5, 'yellow',
      0.7, 'green',
      1, 'lightgreen'
    ];
  }

  return [
    'interpolate',
    ['linear'],
    ['heatmap-density'],
    0, 'rgba(33,102,172,0)',
    0.2, 'rgb(103,169,207)',
    0.3, 'rgb(153,199,223)',
    0.5, 'rgb(209,229,240)',
    0.7, 'rgb(239,138,98)',
    1, 'rgb(178,24,43)'
  ];
};

export const getStaticHeatmapGradient = (showColor: boolean, detailBoost: number = 0): Record<string, string> => {
  if (showColor) {
    return {
      '0.0': 'rgba(255, 0, 0, 0)',
      '0.2': 'red',
      '0.3': 'orange',
      '0.5': 'yellow',
      '0.7': 'green',
      '1.0': 'lightgreen'
    };
  }

  const clampedDetailBoost = Math.max(0, Math.min(1, detailBoost));
  const lowIntensityBias = Math.pow(clampedDetailBoost, 1.45);
  const violetStop = Math.min(0.32, 0.09 + lowIntensityBias * 0.14);
  const skyStop = Math.min(0.46, 0.16 + lowIntensityBias * 0.2);
  const blueStop = Math.min(0.62, 0.28 + lowIntensityBias * 0.24);
  const greenStop = Math.min(0.84, 0.54 + lowIntensityBias * 0.24);
  const yellowStop = Math.min(0.94, 0.76 + lowIntensityBias * 0.16);
  const orangeStop = Math.min(0.985, 0.89 + lowIntensityBias * 0.09);
  const redStop = Math.min(0.998, 0.965 + lowIntensityBias * 0.03);

  return {
    '0.0': 'rgba(183, 232, 255, 0)',
    [violetStop.toFixed(2)]: 'rgb(143,101,226)',
    [skyStop.toFixed(2)]: 'rgb(121,212,255)',
    [blueStop.toFixed(2)]: 'rgb(72,156,255)',
    [greenStop.toFixed(2)]: 'rgb(108,214,144)',
    [yellowStop.toFixed(2)]: 'rgb(255,225,87)',
    [orangeStop.toFixed(2)]: 'rgb(255,152,67)',
    [redStop.toFixed(2)]: 'rgb(230,62,62)',
    '1.0': 'rgb(186,0,0)'
  };
};